import { Mark } from "@/atoms/mark";
import { LanguageControl } from "./language-control";

/**
 * The Gymkee Pay bar (pay-brand-bar 1.1, DS28), above the sheet on every money page.
 *
 * A payment page carries two names and they are not the same kind of name. The COACH is the
 * seller, and his name comes first inside the sheet. GYMKEE PAY is what collects the money, and a
 * person handing over a card is entitled to see whose rails it goes down before reading the
 * price, so this bar sits above the sheet and outside it (gate 20.3, the money-page exemption).
 *
 * The bar is Gymkee Pay's own identity (Mo, 1 Oct 2026): the kit's orange app-icon tile
 * (logo/kit/icon-orange.svg, the Mark atom, the kit's paths untouched) at 32, the smallest tile
 * whose paper mark stays above the kit's 16 minimum, followed by "Gymkee Pay", the PRODUCT'S
 * NAME, in the text face at 16 weight 600 in primary text, 8 after the tile. It is a product
 * name set beside the icon tile, not the wordmark written beside the mark: that is the named
 * exception to rule 309, and the drawn lockup stays on the root page. Orange in both themes,
 * never the coach's colour, never a link: a person paying is not sent off the page by the logo.
 * The tile is decorative and "Gymkee Pay" is text, so the bar reads Gymkee Pay once.
 *
 * It is always the page's one banner landmark. The coach header sits inside main, so the
 * landmarks never move with the data (checkout 1.6 accessibility.banner).
 */

export function BrandBar() {
  return (
    <header className="gap-gk-4 flex w-full items-center">
      <span className="gap-gk-2 flex min-w-0 flex-1 items-center">
        <Mark size={32} />
        <span className="truncate text-[16px] leading-[1.5] font-semibold text-[var(--gk-text-primary)]">
          Gymkee Pay
        </span>
      </span>
      <LanguageControl />
    </header>
  );
}
